/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import star from 'assets/images/star.svg';
import starBorder from 'assets/images/star_border.svg';
import ReactSVG from 'react-svg';
import './RatingStar.scss';

class RatingStar extends Component {
    onClickStart = (e) => {
      const { onSaveUserRating } = this.props;
      const rating = Number(e.currentTarget.dataset.points) + 1;
      onSaveUserRating(rating);
    };

    renderStars = () => {
      const { rating } = this.props;
      const stars = [];
      for (let i = 0; i < 5; i += 1) {
        stars.push(
          <div key={i} className="nw-rating__star" data-points={i} onClick={this.onClickStart}>
            <ReactSVG src={rating > i ? star : starBorder} />
          </div>,
        );
      }
      return stars;
    };

    render() {
      return (
        <div className="nw-rating">
          {this.renderStars()}
        </div>
      );
    }
}

RatingStar.propTypes = {
  // save user rating
  onSaveUserRating: PropTypes.func,
  // user rating
  rating: PropTypes.number,
};

RatingStar.defaultProps = {
  onSaveUserRating: () => {},
  rating: 0,
};

export default RatingStar;
